import { Field } from 'Util/Query';
export class FeaturedCategoryListQuery {

    getQuery(categoryId){

        return new Field('blogFeaturedCategoryFilters')
            .addArgument('blogCategoryId','Int!',categoryId)
            .addFieldList([this.getFeaturedCategoryItemsFields()]);
    }

    getFeaturedCategoryItemsFields(){
        return new Field('items')
            .addFieldList([
                'fieldCode',
                'fieldLabel',
                this.getFeaturedCategoryItemOptionsFields()
            ]);
    }

    getFeaturedCategoryItemOptionsFields(){
        return new Field('options')
            .addFieldList(
                [
                    'label',
                    'value',
                    'resultsCount'
                ]
            );
    }


}

export default new FeaturedCategoryListQuery();
